import { Grid } from "@mui/material";
import PropertyImagesCarrusel from "../PropertyImagesCarrusel";
import MxDetailTitle from "@rf-l1/page/details/MxDetailTitle";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import MxTypography from "@rf-l1/MxTypography";
import MxDetailLocation from "@rf-l1/page/details/MxDetailLocation";
import MxDetailStatus from "@rf-l1/page/details/MxDetailStatus";
import MainDetailPrice from "./MainDetailPrice";
import MxTooltipBasic from "@rf-l1/tooltip/MxTooltipBasic";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import { IconBuildings } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";
import { useNavigate } from "react-router-dom";
import MainDetailFeature from "./MainDetailFeature";
import MainDetailDescription from "./MainDetailDescription";
import MainDetailLocation from "./MainDetailLocation";
import MainDetailGeneral from "./MainDetailGeneral";
import MainDetailCharacteristics from "./MainDetailCharacteristics";
import MainDetailImprovementsAmenities from "./MainDetailImprovementsAmenities";
import PropertySectionErrorBoundary from "../error-boundary/PropertySectionErrorBoundary";
import { useMemo } from "react";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";

interface MainDetailProps {}
const MainDetail = (props: MainDetailProps) => {
  const {
    title,
    name,
    city,
    sector,
    status,
    price,
    isCollection,
    parentId,
    features,
    description,
    id
  } = usePropertyDetailPage();

  const navigate = useNavigate();
  const mainProject = useMemo(() => {
    return parentId !== id;
  }, [parentId, id]);
  return (
    <Grid container item xs={12} borderRadius={1} bgcolor="background.paper">
      <Grid item xs={12}>
        <PropertyImagesCarrusel />
      </Grid>
      <Grid container item xs={12} px={4} py={3} gap={1}>
        {title && (
          <Grid item xs={12}>
            <MxDetailTitle label={title} />
          </Grid>
        )}
        {name && (
          <Grid item xs={12}>
            <MxTypography variant="caption" fontWeight={500} color="primary.main">
              {name}
            </MxTypography>
          </Grid>
        )}

        {city && sector && (
          <Grid item xs={12}>
            <MxDetailLocation city={city} sector={sector} address={null} />
          </Grid>
        )}

        {status && (
          <Grid item xs={12}>
            <MxDetailStatus
              color={status.color}
              label={"PROPIEDAD " + status.label}
            />
          </Grid>
        )}
        {price && (
          <Grid item xs={12}>
            <MainDetailPrice price={price} />
          </Grid>
        )}
        {isCollection && (
          <Grid item xs={12}>
            <MxTooltipBasic msg="Esta propiedad es THE RE/MAX COLLECTION">
              <MxButton2
                testId="the-re-max-collection-button"
                variant="contained"
                fontWeight={500}
              >
                THE RE/MAX COLLECTION
              </MxButton2>
            </MxTooltipBasic>
          </Grid>
        )}

        {mainProject && (
          <Grid item xs={12}>
            <MxButton2
              testId="associated-project-button"
              variant="contained"
              fontWeight={500}
              onClick={() => {
                window.open(
                  C_PATH_ROUTES.REALESTATE.DETAIL(parentId ?? ""),
                  "_blank"
                );
              }}
              endIcon={
                <MxIcons size={20}>
                  <IconBuildings />
                </MxIcons>
              }
            >
              Proyecto asociado
            </MxButton2>
          </Grid>
        )}

        {features && (
          <Grid item xs={12}>
            <MainDetailFeature features={features} />
          </Grid>
        )}

        {description && (
          <Grid item xs={12}>
            <MainDetailDescription descriptions={description} />
          </Grid>
        )}
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={12}>
            <PropertySectionErrorBoundary sectionName="Ubicación">
              <MainDetailLocation />
            </PropertySectionErrorBoundary>
          </Grid>

          <Grid item xs={12}>
            <PropertySectionErrorBoundary sectionName="General">
              <MainDetailGeneral />
            </PropertySectionErrorBoundary>
          </Grid>

          <Grid item xs={12}>
            <PropertySectionErrorBoundary sectionName="Características">
              <MainDetailCharacteristics />
            </PropertySectionErrorBoundary>
          </Grid>

          <Grid item xs={12}>
            <PropertySectionErrorBoundary sectionName="Mejoras y Amenidades">
              <MainDetailImprovementsAmenities />
            </PropertySectionErrorBoundary>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MainDetail;
